export const MESSAGES = {
    FIRST_NAME_REQUIRED: "First name is required",
    LAST_NAME_REQUIRED: "Last name is required",
    MOBILE_VALIDATION_MESSAGE: "Mobile number must be 10 digits",
    MAIL_REQUIRED: "Email is required",
    INVALID_MAIL: "Invalid email format",
    MOBILE_NUMBER_REQUIRED: "Mobile number is required",
    UPDATE_USER: "User updated successfully",
    FAILED_UPDATE_USER: "Failed to update user",
    ERROR_UPDATE_USER: "Error occurred while updating user",
};
